import { isIos, isStandalone } from './pwa';

export type PushCapability =
  | { kind: 'available' }
  | { kind: 'needs_install'; reason: string }   // iPhone/iPad Safari tab: Web Push works only from the Home Screen app
  | { kind: 'denied' }
  | { kind: 'unsupported' }
  | { kind: 'not_configured' };

export function pushCapability(vapidKey: string | null): PushCapability {
  if (!vapidKey) return { kind: 'not_configured' };
  const hasApi = 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
  if (isIos() && !isStandalone()) {
    return { kind: 'needs_install', reason: 'На iPhone напоминания приходят только из приложения на экране «Домой».' };
  }
  if (!hasApi) return { kind: 'unsupported' };
  if (Notification.permission === 'denied') return { kind: 'denied' };
  return { kind: 'available' };
}

function urlBase64ToUint8Array(base64: string): Uint8Array<ArrayBuffer> {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + padding).replace(/-/g, '+').replace(/_/g, '/'));
  const out = new Uint8Array(new ArrayBuffer(raw.length));
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

/** Asks permission and subscribes in this tenant's worker scope. */
export async function subscribePush(scope: string, vapidKey: string): Promise<PushSubscriptionJSON> {
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error(permission === 'denied' ? 'denied' : 'dismissed');
  const reg = await navigator.serviceWorker.getRegistration(scope);
  if (!reg) throw new Error('no_worker');
  const existing = await reg.pushManager.getSubscription();
  const sub = existing ?? (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(vapidKey) }));
  return sub.toJSON();
}
